import { Button } from "./Button";

export default function HeroBanner() {
  return (
    <div
      className="bg-cover bg-center bg-no-repeat lg:h-[400px] w-full rounded-2xl px-4 pt-5 lg:px-20 lg:flex flex-col lg:flex-row items-center justify-between gap-3"
      style={{ backgroundImage: "url(/images/hero-bg.svg)" }}>
      <div className="md:w-[65%] space-y-4">
        <h1 className="text-3xl md:text-5xl !font-black text-white leading-snug flex flex-col">
          <span>Deliver Smarter With</span>
          <span className="text-[#B8FFAC] !font-black">Fez Safe Lockers</span>
        </h1>

        <p className="text-sm lg:text-lg text-white lg:w-[80%]">
          Send or receive packages securely via Fez Safe Lockers for just <span className="font-bold">₦699 </span>
          in Lagos & Abuja or <span className="font-bold">₦2,000</span> from anywhere in Nigeria to Lagos/Abuja.
          Fast, secure, trackable, and available 24/7.
        </p>

        <Button title="Book a Locker Now" className="bg-[#FFA800] text-[#1a1a1a] font-bold py-3 px-6 rounded-lg w-[80%] lg:w-[30%]" />
      </div>

      <figure className="lg:w-[35%] flex items-center justify-center self-end">
        <img
          src="/images/hero-mascot.svg"
          alt="lockerdash_banner"
          className="w-full h-full block object-cover"
        />
      </figure>
    </div>
  );
}
